// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__E9lp4","title":"ClientInsurance_title__IdXgV","itemText":"ClientInsurance_itemText__2qMjQ"};